<template>
  <div class="tabs-wrapper">
    <el-tabs v-model="activeName">
      <el-tab-pane label="预估监控" name="estimateAnalysis"></el-tab-pane>
      <el-tab-pane label="商品" name="commodity"></el-tab-pane>
      <el-tab-pane label="产品" name="product"></el-tab-pane>
      <el-tab-pane label="产品分类" name="productCategory"></el-tab-pane>
      <el-tab-pane label="店铺汇总" name="shopSummary"></el-tab-pane>
      <el-tab-pane label="包件" name="packages" v-if="isAllPlan"></el-tab-pane>
      <el-tab-pane label="新品" name="newProduct" v-if="isReportMonth"></el-tab-pane>
      <el-tab-pane label="A类新品" name="aClass"></el-tab-pane>
      <el-tab-pane label="小件(黑名单)" name="whiteList" v-if="isReportMonth && isAllPlan"></el-tab-pane>
      <el-tab-pane name="abnormalGoods">
        <template slot="label">
          <span>异常商品</span>
          <el-tooltip effect="dark" content="所在月份没有做预销，但是存在实销的商品" placement="top">
            <i class="el-icon-question" style="margin-left: 4px; color: #909399;"></i>
          </el-tooltip>
        </template>
      </el-tab-pane>
      <el-tab-pane name="abnormalProduct">
        <template slot="label">
          <span>异常产品</span>
          <el-tooltip effect="dark" content="所在月份没有做预销，但是存在实销的产品" placement="top">
            <i class="el-icon-question" style="margin-left: 4px; color: #909399;"></i>
          </el-tooltip>
        </template>
      </el-tab-pane>
    </el-tabs>
    <!-- 提报月不展示下载按钮 -->
    <el-button type="text" class="download" @click="download" v-if="activeName !== 'estimateAnalysis'">
      <span class="el-icon-download"></span><span>下载</span>
    </el-button>
    <el-button type="text" class="download" @click="estimateAnalysisDownload" v-if="activeName == 'estimateAnalysis'">
      <span class="el-icon-download"></span><span>下载</span>
    </el-button>
    <!-- doalog -->
    <v-dialog v-model="dialogVisible" :config="dialogConfig" @dialogConfirm="dialogConfirm">
      <div slot="content">
        <download :isAll="isAllPlan" :formData="form" ref="child" v-if="dialogVisible"></download>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  import mixin from '@/views/preSalePlan/utils/mixin.js'
  import download from './download'
  import moment from 'moment'

  export default {
  mixins: [mixin],
  props: ['form'],
  components: { download },
  model: {
    prop: 'tabName',
    event: 'change'
  },
  data() {
    return {
      activeName: '',
      dialogVisible: false,
      dialogConfig: {
        title: '下载',
        confirmCallback: true
      },
      downloadStoreId: '',
    };
  },
  computed: {
    isReportMonth() {
      let planTime = this.planTime;
      let thisTime = moment(new Date()).format('YYYY-MM');
      if(planTime === thisTime) {
        return true;
      }else{
        return false;
      }
    }
  },
  watch: {
    activeName(val) {
      console.log(val);
      isNaN(val) && this.$emit('change', this.activeName)
    },
    storeId(val) {
      this.init();
      this.downloadStoreId = ''
    }
  },
  created() {
    this.$bus.$on('downloadStore', (data)=>{
     this.downloadStoreId = data
    });
    this.tabBarReloadListener();
    this.init();
  },
  methods: {
    // 接收监听事件
    tabBarReloadListener() {
      this.$bus.$off('tabsBarReload');
      this.$bus.$on('tabsBarReload', _=>{
        this.init();
      })
    },
    // 是否是全平台
    async init() {
      if(this.isAllPlan) {
        if(this.isReported) {
          this.activeName = 'estimateAnalysis'
        }else{
          this.activeName = 'packages'
        }
      }else{
        if(this.isReported) {
          this.activeName = 'estimateAnalysis'
        }else{
          this.activeName = 'commodity'
        }
      }
    },
    async estimateAnalysisDownload() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = {
        planTime: this.form.planTime,
        storeId: this.downloadStoreId || this.form.storeId,
        type: this.timeTypeName == '季度' ? 4 : 2
      }
      console.log(this.form);
      let res = await this.$q.preSalePlan.rankingExport({ data, options: {responseType: 'blob'}})
      // let fileName = this.activeName;
      let fileName = this.form.planTime + '预估监控导出';
      this.blobDownload( res, `${fileName}.XLSX`);
      loading.close();
    },
    download() {
      this.dialogVisible = true;
    },
    dialogConfirm() {
      this.$refs['child'].$refs['ruleForm'].validate(valid=>{
        if(valid) {
          this.submit();
        }else{
          console.log('error submit !!!');
        }
      })
    },
    async submit() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let form = this.$refs['child'].form
      let data = {
        ...form,
        planTime: this.form.planTime.substring(0,4),
        storeId: this.form.storeId,
        planType: form.dimension == 3 ? 2 : form.planType,
        pageNum: 1,
        pageSize: 10000
      };
      let res = await this.$q.preSalePlan.downloadList({ data, options: {responseType: 'blob'}})
      let fileName = sessionStorage.getItem('storeName')+'预销计划'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      this.blobDownload( res, `${fileName}.XLSX`);
      this.dialogVisible = false;
      loading.close();
    }
  }
};
</script>

<style lang="stylus" scoped>
  .tabs-wrapper
    background #ffffff
    padding 10px
    position relative
    padding-bottom 0px
    padding-top 0px

  >>> .el-tabs__header
    margin-bottom 0

  .download
    position absolute
    top 10px
    right 15px
    >>> .el-icon-download
      font-size 16px
      position relative
      top 1px
      left 2px
</style>
